export default {
  userAuth: false,
  userInfo: null,
  config: {},
  configAccess: null,
  currencies: null,
  units: [
    {value: 1, label: 'Миллиметры'},
    {value: 2, label: 'Сантиметры'},
    {value: 3, label: 'Метры'},
  ],
  companies: null,
  build: {
    number: '',
    reload: false,
  },
}